
clamp = (val, min, max) -> Math.max(min, Math.min(max, val))
trueMod = (n, m) -> ((n % m) + m) % m


class TagPickerController

    KEYS =
        UP: 38
        DOWN: 40
        RIGHT: 39
        LEFT: 37
        ENTER: 13
        ESC: 27

    ### @ngInject ###
    constructor: ($scope, $http, $q, $element, ApiUrl, TagPickerTree, $analytics) ->
        @http = $http
        @scope = $scope
        @q = $q
        @analytics = $analytics

        root = if $scope.root then $scope.root.split('/') else []
        skip = if $scope.skip then $scope.skip.split(',') else []

        @tree = new TagPickerTree(root, @scope.programId or undefined, skip)
        @tree.onPickTag @pickTag
        @tree.onNodeChange @nodeChange

        @tags = @tags or []
        @tagMap = {}

        @searchBox = $element[0].querySelector('input.search')
        @focuser = $element[0].querySelector('input.focuser')
        @content = $element[0].querySelector('.content')
        @_activeIndex = 0

        @searchModelOptions =
            updateOn: 'default blur'
            debounce:
                default: 300
                blur: 0

        @scope.$watchCollection (=> @tags), @rebuildTagMap


    Object.defineProperties @prototype,
        atRoot: get: -> @root == @current
        root: get: -> @tree.rootNode
        current: get: -> @tree.currentNode
        activeItem: get: -> @nodeItems[@activeIndex]
        activeIndex:
            get: -> @_activeIndex
            set: (value) ->
                @_activeIndex = trueMod(value, @nodeItems.length)
                @indexChanged()
                return

    track: (name, label) ->
        @analytics.eventTrack name,
            category: 'Tag Picker'
            label: label

    tagClass: (tag) ->
        has = @tagSelected(tag)
        return add: !has, remove: !!has

    clearSearch: ->
        @scope.search = ""
        @current.parent.browse()

    nodeChange: (node) =>
        if not node? then return
        if not node.query? then @scope.search = ""
        if node.id == 'search'
            @track 'search', node.query
        else
            @track 'view', node.id
        @nodeItems = node.getItems()
        @nodeItems.splice(0, 0, 'search')
        @activeIndex = 0
        return

    pickTag: (tag) =>
        if @tagSelected tag
            realTag = @tagMap[tag.slug][tag.value]
            @removeTag tag: realTag
        else
            @addTag tag: tag

    tagSelected: (tag) =>
        return !!@tagMap[tag.slug]?[tag.value]

    rebuildTagMap: (tags) =>
        @tagMap = {}
        for tag in tags
            @tagMap[tag.slug] = @tagMap[tag.slug] or {}
            @tagMap[tag.slug][tag.value] = tag
        return

    keyUp: (event) =>
        keycode = event.which or event.charCode or event.keyCode;
        switch keycode
            when KEYS.DOWN then @nextItem(event)
            when KEYS.UP then @previousItem(event)
            when KEYS.LEFT then @goBack(event)
            when KEYS.ENTER then @selectItem(event)
            when KEYS.RIGHT then @goDeeper(event)
        return

    keyPress: (event) =>
        keycode = event.which or event.charCode or event.keyCode;
        if @activeItem != 'search'
            @scope.search += String.fromCharCode(keycode)
            @current.search(@scope.search)
            event.preventDefault()
        return

    hoverItem: (item) ->
        index = @nodeItems.indexOf(item)
        @activeIndex = index if index >= 0
        return

    nextItem: (event) ->
        @activeIndex++
        event.preventDefault()

    previousItem: (event) ->
        @activeIndex--
        event.preventDefault()

    selectItem: (event) ->
        if typeof @activeItem == 'string'
            part = @activeItem.split('_')
            part = part[part.length - 1]
            if part == 'prev'
                group = @nodeItems[@activeIndex + 1]?.parent
                group.prev()
            if part == 'next'
                group = @nodeItems[@activeIndex - 1]?.parent
                if parent.allowPage then group.next() else group.more()
        else
            @activeItem.select()
        event.preventDefault()

    goBack: (event) ->
        if @activeItem != 'search' or @scope.search == ""
            @current.parent?.browse?()
            event.preventDefault()

    goDeeper: (event) ->
        if @activeItem == 'search' then return
        if @activeItem == 'browse'
            @tree.startBrowse()
            event.preventDefault()
        else if @activeItem.browse?
            @activeItem.browse()
            event.preventDefault()
        return

    indexChanged: ->
        if @activeItem == 'search' then @searchBox.focus()
        else @focuser.focus()
        @scope.$broadcast('tagpicker:activeItemChanged', @activeItem)


### @ngInject ###
TagPickerTreeService = ($http, $q, $timeout, ApiUrl) ->

    tagPickerRootURL = ApiUrl.partial('tag')

    class Tree

        constructor: (rootTagPath, programId, skip) ->
            @rootTagPath = rootTagPath or []
            @programId = programId
            @rootUrl = tagPickerRootURL.partial(rootTagPath...)
            @skip = skip

            @rootNode =  new RootNode(@)
            @currentNode = null

            @pickTagHandlers = []
            @nodeChangeHandlers = []

        getBreadcrumb: ->
            return @currentNode.getBreadcrumb()

        queryParams: (extra = {}) ->
            # Wrapper to add base query parameters
            extra.program_id = @programId
            extra.skip = @skip if @skip.length > 0
            return extra

        httpGet: (url, params, path=[]) ->
            params = @queryParams(params)
            url = @rootUrl(path..., url)
            $http.get(url, params: params)
                .then (r) -> r.data.items or r.data.item

        httpGetAll: (slug, params) ->
            url = tagPickerRootURL(slug, 'all')
            params = @queryParams(params)
            $http.get(url, params: params).then (r) -> r.data.items

        browseTo: (node) ->
            @currentNode = node
            @nodeChange(node)
            return

        startBrowse: -> @browseTo(@rootNode.children[0])

        pickTag: (tag) ->
            func(tag) for func in @pickTagHandlers
            return

        nodeChange: (node) ->
            func(node) for func in @nodeChangeHandlers
            return

        createHandler: (list, handler) ->
            index = list.indexOf(handler)
            list.push handler if index == -1
            return =>
                index = list.indexOf(handler)
                list.splice(index, 1) if index >= 0
                return

        onPickTag: (handler) ->
            return @createHandler(@pickTagHandlers, handler)

        onNodeChange: (handler) ->
            return @createHandler(@nodeChangeHandlers, handler)

        dfs: (predicate) ->
            return @rootNode.dfs(predicate)


    class Tag
        # Represents a single tag
        constructor: (data, parent) ->
            {@id, @name, @value, @label, @slug, @description, @tag_for,
             @short_name, @short_label} = data
            defineParent(@, parent)

        Object.defineProperties @prototype,
            tree: get: -> @parent.tree

        select: -> @tree.pickTag(@)


    class TagGroup
        # A list of tags with a header
        constructor: (@label, @slug, tags, parent) ->
            defineParent(@, parent)
            @tags = []
            @limit = 10
            @offset = 0
            @allowPage = true
            @addTag(tag) for tag in tags

        Object.defineProperties @prototype,
            tree: get: -> @parent.tree
            hasNextPage: get: -> @offset + @limit < @tags.length
            hasPreviousPage: get: -> @offset > 0

        disablePaging: ->
            @allowPage = false
            @limit = 3
            return

        enablePaging: ->
            @allowPage = true
            @limit = 10
            return

        nextPage: ->
            if @hasNextPage then @offset += @limit
            @parent.tree.nodeChange(@parent)
            return

        previousPage: ->
            if @hasPreviousPage then @offset = Math.max(0, @offset - @limit)
            @parent.tree.nodeChange(@parent)
            return

        addTag: (tag) =>
            tag = new Tag(tag, @)
            @tags.push tag
            return

        more: ->
            return @parent.viewMore(@)

    class TreeNode

        constructor: (parent) ->
            defineParent(@, parent)
            @tagGroups = []
            @tags = []
            @children = []
            @indexCounter = 0

        Object.defineProperties @prototype,
            tree: get: -> @parent.tree
            icon: value: 'folder'
            items: get: -> @children
            showChildren: value: true
            path: get: ->
                if @slug? then @parent.path.concat(@slug) else @parent.path

        getBreadcrumb: ->
            return @parent.getBreadcrumb().concat(@)

        setIndex: (item) ->
            item.index = ++@indexCounter
            return @index

        getItems: ->
            items = []
            items.push(@children...)
            for group in @tagGroups

                if group.allowPage and group.hasPreviousPage
                    items.push("#{group.slug}_prev")

                start = group.offset
                end = start + group.limit - 1
                items.push(group.tags[start..end]...)

                if group.hasNextPage
                    items.push("#{group.slug}_next")

            return items

        addTagGroup: (data) ->
            group =  new TagGroup(data.label, data.slug, data.tags, @)
            @tagGroups.push group
            @setIndex tag for tag in group.tags
            return group

        addTag: (tag) ->
            tag = new Tag(tag)
            @tags.append tag
            return tag

        addTagType: (tag) ->
            node = new TagTypeNode(tag, @)
            @setIndex node
            @children.push node
            return node

        addCategory: (cat) ->
            node = new TreeNode(@)

            @setIndex(node)
            node.label = cat.label
            node.slug = cat.slug
            node.id = 'cat-' + cat.slug
            node.description = cat.description

            node.addCategory(c) for c in cat.categories
            node.addTagType(tag) for tag in cat.tags

            @children.push node

        browse: => @tree.browseTo(@)

        select: => @browse()

        createSearchNode: (query) ->
            # Create a new search node that searches all tags below this node
            return new SearchNode(query, @)

        disableTagPaging: ->
            group.disablePaging() for group in @tagGroups
            return

        enableTagPaging: ->
            group.enablePaging() for group in @tagGroups
            return

        search: (query) ->
            if query
                searchNode = @createSearchNode(query)
                return searchNode.initalize().then ->
                    searchNode.disableTagPaging()
                    searchNode.browse()
                    return searchNode

            else
                @.browse()
                $q.reject(@)

        dfs: (predicate) ->
            if predicate(@)
                return @
            for child in @children
                child_result = child.dfs(predicate)
                return child_result if child_result
            return null


    class TagTypeNode extends TreeNode

        constructor: (data, parent) ->
            {@label, @full_label, @full_label, @slug, @description} = data
            @id = @slug
            @initalized = false
            super(parent)

        Object.defineProperties @prototype,
            icon: value: 'tags'
            path: get: -> [@slug]

        initalize: ->
            @initalized = true
            @tree.httpGetAll(@slug).then (tags) =>
                group = @addTagGroup(slug: @slug, tags: tags)
                # group.limit = null
                return

        browse: ->
            if not @initalized then @initalize().then => super()
            else super()

        search: (query) ->
            super(query).then (searchNode) ->
                if searchNode.tagGroups.length > 0
                    searchNode.tagGroups[0].label = null
                    searchNode.enableTagPaging()
                    searchNode.tree.nodeChange(searchNode)
                return searchNode


    class RootNode extends TreeNode

        constructor: (tree) ->
            super(tree)
            common = @tree.httpGet('common')
            categories = @tree.httpGet('tree')
            @id = 'root'

            $q.all([common, categories]).then (data) =>
                @addTagGroup(tags) for tags in data[0]
                data[1].label = 'Browse Tags'
                data[1].description = "Explore all tags by category"
                @addCategory(cat) for cat in data[1].categories
                @addTagType(tag) for tag in data[1].tags
                @disableTagPaging()
                @browse()

        Object.defineProperties @prototype,
            isRoot: value: true
            icon: value: 'home'
            tree: get: -> @parent
            items: get: -> @tagGroups
            path: get: -> []

        getBreadcrumb: ->
            return [@]

        viewMore: (tagGroup) ->
            node = new TreeNode(@)
            group = node.addTagGroup(tagGroup)
            group.label = null
            node.label = tagGroup.label
            node.browse()



    class SearchNode extends TreeNode

        constructor: (query, parent) ->
            super(parent)
            @id = 'search'
            @query = query
            @label = 'Search Results'

        initalize: ->
            return @tree.httpGet('search', q: @query, @path).then (data) =>
                @addTagGroup(tagGroup) for tagGroup in data
                return @

        createSearchNode: (query) ->
            new SearchNode(query, @parent)

        viewMore: (tagGroup) ->
            slug = tagGroup.tags[0].slug
            node = @tree.dfs((n) -> n.slug == slug)
            return node.search(@query).then (node) ->
                node.tagGroups[0].label = null
                return node

        search: (query) -> @parent.search(query)

    return Tree


class TagList
    constructor: (data, parent, limit) ->
        defineParent(@, parent)
        defineParent(item, parent) for item in data
        @tagGroups = data
        @limit = limit


class SearchNode extends Node
    constructor: (tags, parent) ->
        super(label: 'Search Results', tags: tags, parent)

    Object.defineProperties @prototype,
        isRoot: value: true
        tagGroups: get: -> @tags


defineParent = (item, parent) ->
    Object.defineProperty item, 'parent',
        value: parent
        configurable: true
    return


tagPickerDirective = ->
    restrict: 'E'
    templateUrl: 'util/tags/picker'
    scope:
        root: '@'
        skip: '@'
        programId: '='
    controller: TagPickerController
    controllerAs: 'ctrl'
    bindToController:
        tags: '='
        addTag: '&'
        removeTag: '&'
        newTag: '&'

tagGroupList = ->
    restrict: 'A'
    templateUrl: 'util/tags/groupList'
    scope: group: '=dybTagGroupList'
    require: '^dybTagPicker'
    link: (scope, element, attrs, tagPicker) ->
        scope.ctrl = tagPicker



module.directive 'dybTagPicker', tagPickerDirective
module.directive 'dybTagGroupList', tagGroupList

module.factory 'TagPickerTree', TagPickerTreeService

